import { Grid, Typography, Button } from '@material-ui/core';
import React, { FunctionComponent, useContext, useEffect, useState } from 'react';
import classes from "./style.module.scss"
import ProfileCard from '../../components/Cards/profileCard';
import usersRepository from 'client-sdk/src/Repository/users-repository';
import handleError from '../../utils/handleError';


const Profile: FunctionComponent<any> = (props: any) => {
    const [user, setUser] = useState(null)
    const userId = localStorage.getItem("userId");
    useEffect(() => {
        getUserWithId(userId)
    }, [])

    const getUserWithId = async (id: string) => {
        try {
            const response = await usersRepository.getProfile({})
            setUser(response.data)
        } catch (error) {
            handleError(error)
        }
    }

    return (
        <>
            <Typography variant="h6" component="h2">
                حساب کاربری
            </Typography>
            <div className={classes.container}>
                <ProfileCard data={user} />
            </div>
        </>
    )
}

export default Profile;